<template>
  <v-img :src="img" :aspect-ratio="1" v-bind="$attrs" />
</template>

<script>
/* eslint-disable global-require */

const ICONS = {
  wheel: require('@/assets/img/games/wheel/icon.png'),
  spinners: require('@/assets/img/games/spinners/icon.png'),
  cases: require('@/assets/img/games/cases/icon.png'),
  coinflip: require('@/assets/img/games/coinflip/icon.png'),
  dice: require('@/assets/img/games/dice/icon.png'),
  caseBattles: require('@/assets/img/games/case-battles/icon.png'),
}

export default {
  props: {
    game: {
      type: String,
      required: true,
    },
  },
  computed: {
    img() {
      return ICONS[this.game]
    },
  },
}
</script>
